/** Short words that never carry a filter on their own – bolding them would only add noise. */
const GLUE_WORDS = new Set(('a an the for in at on of to and with under over below around about approx near by from '
  + 'between up max budget people guests guest pax persons ppl adults is are be we our my need want looking').split(' '));

/** Every checked word costs one more parse (a few ms each); the row only shows the start of a long text anyway. */
const MAX_CHECKED_WORDS = 30;

const HTML_ENTITIES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

const escapeHtml = (text) => text.replace(/[&<>"']/g, (char) => HTML_ENTITIES[char]);

const searchOf = (result) => JSON.stringify(result ? [result.intent, result.location, result.search] : null);

const coreOf = (token) => token.toLowerCase().replace(/^[^\w$£€]+|[^\w]+$/g, '');

/**
 * A word counts as recognised when leaving it out changes the search. So in "big birthday party" only "birthday" is
 * bold: without "party" the parser still finds the birthday party.
 *
 * @param {string} text
 * @param {function(string): ?object} parse parseSearch() bound to the page
 * @returns {string} the text, HTML-escaped, with recognised words wrapped in <b>
 */
export const highlightRecognised = (text, parse) => {
  const tokens = text.split(/(\s+)/); // words at even indexes, the whitespace between them at odd ones
  const baseSearch = searchOf(parse(text));
  let checked = 0;

  const recognised = tokens.map((token, i) => {
    const core = coreOf(token);
    if (i % 2 === 1 || !core || GLUE_WORDS.has(core) || checked >= MAX_CHECKED_WORDS) {
      return false;
    }

    checked += 1;
    const withoutWord = tokens.map((other, j) => (j === i ? ' ' : other)).join('');

    return searchOf(parse(withoutWord)) !== baseSearch;
  });

  return tokens
    .map((token, i) => {
      if (!recognised[i]) {
        return escapeHtml(token);
      }

      // trailing punctuation stays outside the bold
      const [, word, punctuation] = token.match(/^(.*?)([,.;:!?)]*)$/);

      return `<b>${escapeHtml(word)}</b>${escapeHtml(punctuation)}`;
    })
    .join('')
    .replace(/<\/b>(\s+)<b>/g, '$1');
};
